module.exports = __webpack_public_path__ + "img/korea-25.a57a1086.png";